<template>
  <div id="app">
    <router-view></router-view>
    <MobileConsole />
  </div>
</template>

<script>
import MobileConsole from '@/components/MobileConsole/index.vue'

export default {
  name: 'app',
  components: {
    MobileConsole
  }
}
</script>

<style>
</style>
